<template>
  <div class="container">

    <!-- HEADER -->
    <div class="header row p-0 m-0">
      <div class="col-12 col-lg-6 p-0 m-0">
        <img :src="`${publicPath}img/Grupo de desplazamiento 1.jpg`" data-aos="fade-left" data-aos-duration="1000" class="img-responsive">
      </div>
      <div class="col-12 col-lg-6 text-start p-5">
        <h1 class="text-blue mt-3">{{ $t('enresumen.title') }}</h1>
        <p>{{ $t('enresumen.proposito') }}</p>
      </div>
    </div>
    <!-- end HEADER -->

    <section class="p-0 p-lg-5 pb-lg-0 mx-0 mx-lg-5">
      <div class="g-0 p-0 m-0">
        <h2 class="my-5">{{ $t('enresumen.principales') }}</h2>
        <h3>{{ $t('enresumen.afiliacion') }}</h3>
        <div class="container border border-light p-3 m-0" data-aos="fade-in" data-aos-duration="1000" data-aos-id="start-counter-informe">
          <div class="row align-items-center">
            <div class="col-12 col-lg">
              <h2 class="p-0 m-0">
                <AnimatedNumber
                    ref='counter_personas'
                    :startAmount='0'
                    :endAmount='1581861'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                />
                </h2>
              <p class="textSmall" v-html="$t('enresumen.personas')"></p>
            </div>
            <div class="col-12 col-lg-auto px-0 mx-0"><h1>=</h1></div>
            <div class="col-12 col-lg">
              <h2 class="p-0 m-0">
                <AnimatedNumber
                    ref='counter_ajena'
                    :startAmount='0'
                    :endAmount='1300162'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
              <p class="textSmall">{{ $t('enresumen.ajena') }}</p>
            </div>
            <div class="col-12 col-lg-auto px-0 mx-0"><h1>+</h1></div>
            <div class="col-12 col-lg">
              <h2 class="p-0 m-0">
                <AnimatedNumber
                    ref='counter_propia'
                    :startAmount='0'
                    :endAmount='281699'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
              <p class="textSmall">{{ $t('enresumen.propia') }}</p>
            </div>
            <div class="col-12 col-lg border-start border-light">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_empresas'
                  :startAmount='0'
                  :endAmount='157115'
                  :duration='2'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall">{{ $t('enresumen.empresas') }}</p>
            </div>
          </div>
        </div>
        <hr class="filigrana">

        <h3>{{ $t('enresumen.cuidado') }}</h3>
        <div class="container border border-light p-3 m-0" data-aos="fade-in" data-aos-duration="1000" data-aos-id="start-counter-cuidado">
          <div class="row align-items-start">
            <div class="col-12 col-lg-4 px-0 px-lg-5 mb-5 mb-lg-0">
              <img :src="`${publicPath}img/Grupo 592.png`" data-aos="fade-down" data-aos-duration="1000" class="img-responsive mb-3">
              <p class="text-black"><strong>{{ $t('enresumen.red') }}</strong></p>
              <h2><AnimatedNumber
                  ref='counter_centros'
                  :startAmount='0'
                  :endAmount='133'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('enresumen.centros') }}</p>
              <h2>
                <AnimatedNumber
                    ref='counter_control'
                    :startAmount='0'
                    :endAmount='2'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                />
              </h2>
              <p class="textSmall text-black" v-html="$t('enresumen.area')"></p>
              <h2><AnimatedNumber
                  ref='counter_hospi'
                  :startAmount='0'
                  :endAmount='2'
                  :duration='2'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black" v-html="$t('enresumen.hospitalarios')"></p>
            </div>
            <div class="col-12 col-lg-4 px-0 px-lg-5 mb-5 mb-lg-0">
              <img :src="`${publicPath}img/Grupo 607.png`" data-aos="fade-down" data-aos-delay="200" data-aos-duration="1000" class="img-responsive mb-3">
              <p class="text-black"><strong>{{ $t('enresumen.mejora') }}</strong></p>
              <h2><AnimatedNumber
                  ref='counter_inversion'
                  :startAmount='0'
                  :endAmount='5.4'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='1'
                  :autoinit='true'
                  @finished='counterFinished'
              /><small>M€</small></h2>
              <p class="textSmall text-black">{{ $t('enresumen.inversion') }}</p>
              <p class="text-black"><strong>{{ $t('enresumen.actuaciones') }}</strong></p>
              <p class="textSmall text-black">{{ $t('enresumen.finalizacio') }}</p>
              <p class="textSmall text-black">{{ $t('enresumen.traslado') }}</p>
              <p class="textSmall text-black">{{ $t('enresumen.reforma') }}</p>
              <p class="textSmall text-black">{{ $t('enresumen.inicio') }}</p>
            </div>
            <div class="col-12 col-lg-4 px-5 mb-5 mb-lg-0">
              <img :src="`${publicPath}img/Grupo 617.png`" data-aos="fade-down"  data-aos-delay="400" data-aos-duration="1000" class="img-responsive mb-3">
              <p class="text-black"><strong>{{ $t('enresumen.excelente') }}</strong></p>
              <p class="textSmall text-blue">{{ $t('enresumen.presencial') }}</p>
              <h2 class="pb-0 mb-0"><AnimatedNumber
                  ref='counter_visitas'
                  :startAmount='0'
                  :endAmount='1316524'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('enresumen.visitas') }}</p>
              <h2 class="pb-0 mb-0"><AnimatedNumber
                  ref='counter_sesiones'
                  :startAmount='0'
                  :endAmount='413241'
                  :duration='2'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('enresumen.sesiones') }}</p>
              <h2 class="pb-0 mb-0"><AnimatedNumber
                  ref='counter_ingresos'
                  :startAmount='0'
                  :endAmount='5665'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('enresumen.ingresos') }}</p>
              <hr>
              <p class="textSmall text-blue"><strong>{{ $t('enresumen.clinica') }}</strong></p>
              <h2 class="pb-0 mb-0"><AnimatedNumber
                  ref='counter_consultas'
                  :startAmount='0'
                  :endAmount='15107'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('enresumen.consultas') }}</p>
              <hr>
              <p class="textSmall text-blue"><strong>{{ $t('enresumen.valoracion') }}</strong></p>
              <h2 class="pb-0 mb-0"><AnimatedNumber
                  ref='counter_puntos'
                  :startAmount='0'
                  :endAmount='7.75'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='2'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('enresumen.puntos') }}</p>

              <hr>
              <p class="textSmall text-blue"><strong>{{ $t('enresumen.destaca') }}</strong></p>
              <h2 class="pb-0 mb-0"><AnimatedNumber
                  ref='counter_destaca'
                  :startAmount='0'
                  :endAmount='8.61'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='2'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('enresumen.puntos') }}</p>

            </div>
          </div>
        </div>
        <hr class="filigrana">

        <h3>{{ $t('enresumen.equipo') }}</h3>
        <div class="container border border-light p-3 m-0" data-aos="fade-in" data-aos-duration="1000" data-aos-id="start-counter-equipo">
          <div class="row align-items-start">
            <div class="col">
            <img :src="`${publicPath}img/Grupo 656.png`" data-aos="fade-down" data-aos-duration="1000" class="img-responsive mb-3">
            </div>
          </div>
          <div class="row align-items-start">
            <div class="col-12 col-lg">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_p_trabajadoras'
                  :startAmount='0'
                  :endAmount='1910'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('enresumen.trabajadoras') }}</p>
            </div>
            <div class="col-4 col-lg-2 px-0 mx-lg-0 m-auto">
              <hr>
            </div>
            <div class="col-12 col-lg">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_mujeres'
                  :startAmount='0'
                  :endAmount='66.75'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='2'
                  :autoinit='true'
                  @finished='counterFinished'
              />%</h2>
              <p class="textSmall text-black">{{ $t('literals.mujeres') }}</p>
            </div>
            <div class="col-12 col-lg-auto px-0 mx-0"><h1>+</h1></div>
            <div class="col-12 col-lg">
              <h2 class="p-0 m-0">
                <AnimatedNumber
                    ref='counter_hombres'
                    :startAmount='0'
                    :endAmount='33.25'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='2'
                    :autoinit='true'
                    @finished='counterFinished'
                />%</h2>
              <p class="textSmall text-black">{{ $t('literals.hombres') }}</p>
            </div>
          </div>
          <hr class="my-5">
          <div class="row align-items-start">
            <div class="col-lg">
              <p class="text-black"><strong>{{ $t('enresumen.programas') }}</strong></p>
            </div>
          </div>
          <div class="row align-items-start">
            <div class="col-lg px-3">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_cursos'
                  :startAmount='0'
                  :endAmount='578'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('enresumen.cursos') }}</p>
            </div>
            <div class="col-lg px-3">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_participantes'
                  :startAmount='0'
                  :endAmount='13909'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('enresumen.participantes') }}</p>
            </div>
            <div class="col-lg px-3">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_horas'
                  :startAmount='0'
                  :endAmount='86293'
                  :duration='2'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('enresumen.horas') }}</p>
            </div>
            <div class="col-lg px-3">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_distancia'
                  :startAmount='0'
                  :endAmount='91'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              />%</h2>
              <p class="textSmall text-black">{{ $t('enresumen.horas_formacion') }}</p>
            </div>
            <div class="col-lg px-3">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_satisfaccion'
                  :startAmount='0'
                  :endAmount='8.9'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='1'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('enresumen.sat_y_ef') }}</p>
            </div>

          </div>
        </div>
        <hr class="filigrana">

        <h3>{{ $t('enresumen.solvencia') }}</h3>
        <div class="container border border-light p-3 m-0" data-aos="fade-in" data-aos-duration="1000" data-aos-id="start-counter-solvencia">
          <div class="row align-items-start">
            <div class="col-lg">
              <p class="text-black">&nbsp;&nbsp;&nbsp;</p>
            </div>
          </div>
          <div class="row align-items-start mb-5">
            <div class="col-lg px-3">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_ing_cot'
                  :startAmount='0'
                  :endAmount='1293'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /> M€</h2>
              <p class="textSmall text-black">{{ $t('enresumen.ing_cot') }}</p>
            </div>
            <div class="col-lg px-3">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_patrimonio'
                  :startAmount='0'
                  :endAmount='411.98'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='2'
                  :autoinit='true'
                  @finished='counterFinished'
              /> M€</h2>
              <p class="textSmall text-black">{{ $t('enresumen.patrimonio') }}</p>
            </div>
            <div class="col-lg px-3">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_resultado'
                  :startAmount='0'
                  :endAmount='24.48'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='2'
                  :autoinit='true'
                  @finished='counterFinished'
              /> M€</h2>
              <p class="textSmall text-black">{{ $t('enresumen.resultado') }}</p>
            </div>
          </div>
        </div>
        <hr class="filigrana">

      </div>
    </section>

    <!-- NAVEGACIÓ PRE-FOOTER -->
    <hr>
    <div class="row p-0 g-0 mb-3">
      <div class="col-6 p-0 m-0 pb-3 text-start">
        <localized-link class="footerLink" to="/nuestra-actuacion-en-2021"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.nuestra-actuacion-en-2021") }}</localized-link>
      </div>
      <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
        <localized-link class="footerLink" to="/nuestra-actuacion-en-2021/asistencia-sanitaria-personalizada">{{ $t("nav.asistencia-sanitaria-personalizada") }} <img :src="`${publicPath}img/arrowRight.png`" class="img-responsive arrowsFooter"></localized-link>
      </div>
    </div>

  </div>
</template>

<script>

import AnimatedNumber from 'vue3-autocounter'

export default {
  components: {
    AnimatedNumber,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      separator: '.',
      decimal_separator: ','
    }
  },
  mounted() {
    document.addEventListener('aos:in:start-counter-informe', this.startCounter);
    document.addEventListener('aos:in:start-counter-cuidado', this.startCounterCuidado);
    document.addEventListener('aos:in:start-counter-equipo', this.startCounterEquipo);
    document.addEventListener('aos:in:start-counter-solvencia', this.startCounterSolvencia);


    if(this.$i18n.locale=="en"){
      this.separator = ',';
      this.decimal_separator = '.';
    } else {
      this.separator = '.';
      this.decimal_separator = ',';
    }
  },
  methods: {
    startCounter() {
      if (this.$refs.counter_personas != null) {
        this.$refs.counter_personas.start();
      }
      if (this.$refs.counter_ajena != null) {
        this.$refs.counter_ajena.start();
      }
      if (this.$refs.counter_propia != null) {
        this.$refs.counter_propia.start();
      }
      if (this.$refs.counter_empresas != null) {
        this.$refs.counter_empresas.start();
      }
    },

    startCounterCuidado() {
      if (this.$refs.counter_centros != null) {
        this.$refs.counter_centros.start();
      }
      if (this.$refs.counter_control != null) {
        this.$refs.counter_control.start();
      }
      if (this.$refs.counter_hospi != null) {
        this.$refs.counter_hospi.start();
      }
      if (this.$refs.counter_inversion != null) {
        this.$refs.counter_inversion.start();
      }
      if (this.$refs.counter_visitas != null) {
        this.$refs.counter_visitas.start();
      }
      if (this.$refs.counter_sesiones != null) {
        this.$refs.counter_sesiones.start();
      }
      if (this.$refs.counter_ingresos != null) {
        this.$refs.counter_ingresos.start();
      }
      if (this.$refs.counter_consultas != null) {
        this.$refs.counter_consultas.start();
      }
      if (this.$refs.counter_puntos != null) {
        this.$refs.counter_puntos.start();
      }
      if (this.$refs.counter_destaca != null) {
        this.$refs.counter_destaca.start();
      }
    },

    startCounterEquipo() {
      if (this.$refs.counter_p_trabajadoras != null) {
        this.$refs.counter_p_trabajadoras.start();
      }
      if (this.$refs.counter_mujeres != null) {
        this.$refs.counter_mujeres.start();
      }
      if (this.$refs.counter_hombres != null) {
        this.$refs.counter_hombres.start();
      }
      if (this.$refs.counter_cursos != null) {
        this.$refs.counter_cursos.start();
      }
      if (this.$refs.counter_participantes != null) {
        this.$refs.counter_participantes.start();
      }
      if (this.$refs.counter_horas != null) {
        this.$refs.counter_horas.start();
      }
      if (this.$refs.counter_distancia != null) {
        this.$refs.counter_distancia.start();
      }
      if (this.$refs.counter_satisfaccion != null) {
        this.$refs.counter_satisfaccion.start();
      }
    },
    startCounterSolvencia(){
      if (this.$refs.counter_ing_cot != null) {
        this.$refs.counter_ing_cot.start();
      }
      if (this.$refs.counter_patrimonio != null) {
        this.$refs.counter_patrimonio.start();
      }
      if (this.$refs.counter_resultado != null) {
        this.$refs.counter_resultado.start();
      }
    }
  }
}
</script>
